<template>
	<div class="plr-16 box-s" :class="{'pb-30': padShow }" id="nodes">

		<!-- 每道题上部的题号和类型 -->
      <div :class="{ 'pt-66': data.stuff }">
				<div class="quest_header flexs h66 bg_f" :class="{ 'ps_top': data.stuff, 'plr-16': data.stuff }">
					<div class="c1 fz-16 mb-6"> <span class="fz-28 fw-500">{{qusetNum}}</span> <span class="fw-500">/</span> <span class="c2">{{length}}</span> </div>
          <template v-if="!data.stuff">
            <div v-if="question_type == 1" class="tag_class ml-5 bg_ff c13">单选题</div>
						<div v-if="question_type == 2" class="tag_class ml-5 bg_dc c12">多选题</div>
						<div v-if="question_type == 3" class="tag_class ml-5 bg_ea c11">判断题</div>
						<div v-if="question_type == 5" class="tag_class ml-5 bg_d8 c0">填空题</div>
						<div v-if="question_type == 4" class="tag_class ml-5 bg_d8 c0">简答题</div>
					</template>
					<div v-else class="tag_class ml-5 bg_bb c16">材料题</div>
				</div>
			</div>
      
			<!-- 材料题总题干 -->
			<div v-if="data.stuff && showStuff" class="pt-155">
				<div class="mb-22 box_shaw_6 ps_top top66 plr-16 bg_f box-s">
					<div class="over-auto cail" :ref="'DOM'+(qusetNum - 1 )" :style="{ 'height': cheight + 'px' }" :class="{ 'trans': showtrans }">
						<div class="fz-14 fw-500 c1" v-if="data.stuff && data.stuff"  v-html="data.stuff"></div>
					</div>
					<div class="flexs flex-center box-s c0 fz-12 fw-500 l-h-40" @click="showHe">
						<div class="flexs flex-center l-h-40" v-if="showFlag">
							<div>{{txtflag? '收起': '展开'}}</div>
							<span v-if="!txtflag" class="iconfont icon-arrow-down fz-10 ml-7"></span>
							<span v-else class="iconfont icon-shangjiantou fz-10 ml-7"></span>
						</div>
					</div>
				</div>
			</div>

			<div v-if="data.stuff && !showStuff" class="pt-155">
				<div class="mb-22 box_shaw_6 ps_top top66 plr-16 bg_f box-s">
					<div class="over-auto cail h98">
						<div class="fz-14 fw-500 c1" v-if="data.stuff && data.stuff"  v-html="data.stuff"></div>
					</div>
					<div class="flexs flex-center box-s c0 fz-12 fw-500 l-h-40">
						<div class="flexs flex-center l-h-40" v-if="showFlag">
							<div>{{txtflag? '收起': '展开'}}</div>
							<span v-if="!txtflag" class="iconfont icon-arrow-down fz-10 ml-7"></span>
							<span v-else class="iconfont icon-shangjiantou fz-10 ml-7"></span>
						</div>
					</div>
				</div>
			</div>

			<!-- 小题题干 -->
			<div class="fz-14 fw-500 c1 mb-22" v-html="data.question_stem"></div>
      
			<!-- 每道题的主体 -->
			<div class="">
				<!-- 单选题 -->
				<ul class="fz-14 c1" v-if="question_type == 1">
					<li class="flexs mb-22 pd-20-16 bg_f8  b-radius-6 bb-ff box-s flex-jus" :class="{ 'checked': data.right_answer[0] == Object.keys(item)[0], 'error_checked': data.student_answer[0] == Object.keys(item)[0] && data.student_answer[0] != data.right_answer[0], 'tag_active':  data.student_answer.length == 0 && data.right_answer[0] == Object.keys(item)[0]}" v-for="(item, index) in data.prepare_option" :key="index" >
						<div class="flexs flex1">
              <div class="">{{Object.keys(item)[0]}}.</div>
						  <div class="ml-6" v-html="item[Object.keys(item)[0]]"></div>
            </div>
            <div class="ml-10">
							<img v-if=" data.student_answer[0] == Object.keys(item)[0] && data.student_answer[0] != data.right_answer[0]" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
							<div v-else-if="data.student_answer.length == 0 && data.right_answer[0] == Object.keys(item)[0]" class="wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
              <img v-else-if="data.right_answer[0] == Object.keys(item)[0]" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
              
            </div>
					</li>
				</ul>

				<!-- 判断题 -->
				<ul class="fz-14 c1" v-if="question_type == 3">
					<li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{  'checked': data.right_answer == 'true', 'error_checked': data.student_answer == 'true' && data.right_answer == 'false', 'tag_active': data.student_answer === '' && data.right_answer == 'true' }" >
						<div class="flexs">
              <div class="">A.</div>
						  <div class="ml-6" >正确</div>
            </div>
            <img v-if="data.student_answer == 'true' && data.right_answer == 'false'" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
					  <div v-else-if="data.student_answer === '' && data.right_answer == 'true'" class="wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
            <img v-else-if="data.right_answer == 'true'" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
              
					</li>

					<li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{  'checked': data.right_answer == 'false', 'error_checked': data.student_answer == 'false' && data.right_answer == 'true', 'tag_active': data.student_answer === '' && data.right_answer == 'false' }">
						<div class="flexs">
              <div class="">B.</div>
						  <div class="ml-6" >错误</div>
            </div>
            <img v-if="data.student_answer == 'false' && data.right_answer == 'true'" 
						class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
						<div v-else-if="data.student_answer === '' && data.right_answer == 'false'" class="wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
            <img v-else-if="data.right_answer == 'false'" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
					</li>
          
				</ul>
				

				<!-- 多选题 -->
				<div v-if="question_type == 2">
					<ul class="fz-14 c1">
						<li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{  'checked': data.right_answer.indexOf(Object.keys(item)[0]) != -1, 'error_checked': data.right_answer.indexOf(Object.keys(item)[0]) == -1 && data.student_answer.indexOf(Object.keys(item)[0]) != -1,'tag_active': data.right_answer.indexOf(Object.keys(item)[0]) != -1 && data.student_answer.indexOf(Object.keys(item)[0]) == -1}" v-for="(item, index) in data.prepare_option" :key="index" >
							<div class="flexs flex1">
								<div class="">{{Object.keys(item)[0]}}.</div>
								<div class="ml-6" v-html="item[Object.keys(item)[0]]"></div>
							</div>
							<div class="ml-10">
								<img v-if="data.right_answer.indexOf(Object.keys(item)[0]) == -1 && data.student_answer.indexOf(Object.keys(item)[0]) != -1" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
								<div v-else-if="data.right_answer.indexOf(Object.keys(item)[0]) != -1 && data.student_answer.indexOf(Object.keys(item)[0]) == -1" class="wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
								<img v-else-if="data.right_answer.indexOf(Object.keys(item)[0]) != -1" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
								
							</div>
						</li>
					</ul>

				</div>

				<!-- 填空题/简答题 -->
				<div v-if="question_type == 4 || question_type == 5">
          <div  class="textarea_box mb-12">
						<textarea class="textarea" v-model="data.student_answer" :readonly="true" cols="30" rows="10"></textarea>
					</div>

					<div class="mb-22" v-if="data.answer_picture">
            <addImg :showDel="false" :isAnswer="false" :imgList="data.answer_picture"/>
					</div>

				</div>

			</div>
      
			<!-- 答案 -->
      <div class="animal pt-22">
				<div class="mb-22">
					<div class="flexs flex-jus fw-500 c1">
						<div class="flexs">
							<img class="wh_32 mr-10" src="../../assets/img/icon/answer_icon.png" alt="">
							<div class="l-h-16 fz-16  ">题目解析～巩固你的知识吧！</div>
						</div>
						<div class="flexs fz-10 bg_f9 flex-center b-radius-10 wh_74_20" @click="jumpReaction">
							纠错反馈
							<img class="wh_4_6 ml-8" src="../../assets/img/icon/gray_right_arrow_icon.png" alt="">
						</div>
					</div>
				</div>

				<div class=" fz-14 fw-500 c1 mb-10" :class="{ 'flexs': !(question_type == 4 || question_type == 5) }">
					<div class="mr-30 flexs flex-align-start " :class="{ 'mb-10': question_type == 4 || question_type == 5 }">
						<div class="w75 wrp">正确答案：</div>
						<div class="c0 flex1" v-html="data.right_answer" v-if="question_type == 4 || question_type == 5"></div> 
						<div class="c0 flex1" v-else>
							{{right_answer }}
						</div> 
					</div>
					<div class="flex flex-align-start">
						<div class="w75 wrp">你的答案：</div>
						<div class="c0 flex1" :class="{ 'c9': data.is_result == 0 || data.is_result == 2}">
							{{student_answer }}
						</div> 
					</div>
          
					
				</div>
				<div class="mb-10" v-if="data.answer_picture">
					<addImg :imgList="data.answer_picture" :showDel="false" :showAdd="false"/>
				</div>

				<div class="fz-14  c1">
					<div class="fw-500 mb-8">题目解析：</div>
					<div v-if="data.analysis" v-html="data.analysis"></div>
				</div>
			</div>
  
      <div>
        
      </div>
    <qusetBottom :questBtn="questBtn" :cData="cData" :isAnswer="false" :length="length" :collectFalg="collectFalg" :qusetNum="qusetNum" @getQuest="getQuest" @collect="collect" @quertCard="quertCard" :colectData="cData"></qusetBottom>
		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
	import loading from "@/components/loading"
	import { showAnalysis } from '@/api/api.js'
	import {getShowPadding} from "@/utils/common.js";
	import qusetBottom from "@/components/qusetBottom.vue";
	import addImg from "@/components/addImg.vue";
	export default {
		components: {
      qusetBottom,
			addImg,
			loading
		},
		data() {
			return {
				loadFlag: false,
        padShow: false, //是否展示底部30padding
        data: {},
        qusetNum: 1, //第几道题
        question_type: 0, // 题的类型 1-单选 2-多选 3-判断 4-简答 5-填空 6-材料
        number: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U","V", "W", "X", "Y", "Z"],//题目前序号
        showHeader: false,  //材料题头部动画
				hideHeader: false, //材料题头部动画
				flag: false, //材料题头部动画
				txtflag: false, //材料题头部动画
				timeflag: false, //材料题头部动画
        length: 0,
				collectFalg: true, //是否收藏到错题本
        cData: {
					question_id: '',
					model_type: 6,
					way: 3,
					base_user_id: ''
				},//收藏接口需要数据
        student_answer: '',//学生答案
				right_answer:'',//正确答案
				questBtn: false,
				cheight: '',
				commonHeight: '',
				showFlag: false,
				showtrans: false,
				showStuff: false
				
			};
		},
		created() {
			this.qusetNum = this.$route.query.qusetNum?this.$route.query.qusetNum : 1
			this.cData.base_user_id = this.$route.query.answer_id
      this.initData()
		},
		mounted(){
      this.padShow = getShowPadding()
		},

		methods: {
			init(){
        this.showHeader = false
        this.flag = false
        this.txtflag = false
        this.timeflag = false
			},
      async initData(){
				
        this.loadFlag = true
			  const res = await showAnalysis({ answer_id: this.$route.query.answer_id.toString(), page: this.qusetNum })
        this.loadFlag = false
				if(res.code == 1000){
					this.init()
          this.length = res.data.pageTotal
          this.data = res.data.list
          this.question_type = this.data.question_type
          const s_answer = this.data.student_answer
          const r_answer = this.data.right_answer
          
					this.student_answer = !Array.isArray(s_answer)? (s_answer == ''? '未答':(s_answer == 'true'? '正确': s_answer == 'false'?'错误':s_answer)): (s_answer.length == 0? '未答':(s_answer.length == 1? s_answer[0]:s_answer.join('')))

          this.right_answer = !Array.isArray(r_answer)? (r_answer === ''? '未答':(r_answer == 'true'?'正确': r_answer == 'false'? '错误':r_answer)): (r_answer.length == 0? '未答':(r_answer.length == 1? r_answer[0]:r_answer.join('')))
					if(this.data.stuff){
						this.cheight = ''
						this.commonHeight = ''
						this.showHeader = false
						this.txtflag = false
						this.showStuff = true
            this.$nextTick(()=>{
							const r = document.documentElement.clientWidth / 375
							this.commonHeight = this.$refs['DOM'+ (this.qusetNum - 1)].offsetHeight * r
							this.cheight = 98 * r
							this.showFlag = this.commonHeight > this.cheight
							this.showtrans = true
						})
					}
					this.cData.question_id =  this.data.question_id   
					this.collectFalg = this.data.collect? true: false
				} else {
					this.$toast(res.msg)
				}
			},


			// 上一页，下一页
			getQuest(type){
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				if(type == '1'){
					this.qusetNum = this.qusetNum - 1
				} else if (type == '2') {
					this.qusetNum =this.qusetNum + 1
				}
        this.initData()
				
			},


			// 收藏
			collect(collectFalg){
        this.collectFalg = !collectFalg
			},
			// 查看答题卡
			quertCard(data){
				if(!data){
          this.$router.replace({path: '/historyanalycard', query:{ answer_id: this.$route.query.answer_id, qusetNum: this.qusetNum } })
				}
        
			},
      
			// 材料题展开收起
			showHe(){
				if(!this.showFlag) return
				if(!this.showHeader){
					const h = document.documentElement.clientHeight * (document.documentElement.clientWidth / 375) * 0.55
					this.cheight = this.commonHeight > h ? h : this.commonHeight
				} else {
					this.cheight = 98 * (document.documentElement.clientWidth / 375)
					this.$nextTick(() => {
						this.$refs['DOM'+ (this.qusetNum - 1)][0]?this.$refs['DOM'+ (this.qusetNum - 1)][0].scrollTo(0,0):this.$refs['DOM'+ (this.qusetNum - 1)].scrollTo(0,0);
					})
				}
				
				this.showHeader = !this.showHeader
				this.txtflag = this.showHeader
				
        
			},

			// 跳转错题反馈
			jumpReaction(){
        this.$router.push({ path: '/reaction', query: { question_id: this.cData.question_id,  type: 'history', answer_id: this.$route.query.answer_id, qusetNum: this.qusetNum  } })
			}

		}
	};
</script>
<style lang="less" scoped>
ul li:last-child {
	margin-bottom: 0;
}

.animal {
	animation: show 1s;
	animation-fill-mode:forwards;
}

@keyframes show {
	0% {
		display: none;
	}
	100% {
		display: block;
	}
}

.h100px {
  height: 98px;
	transition: all 1s;
}
.heightamimal {
	overflow: auto;
	height: 50vh;
}
.heightamimal::-webkit-scrollbar {
  display: none;
}

</style>
